import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';

export interface UpdateLoanParams {
  loanId: string;
  metadata: {
    documentGroupingId: string;
  };
}

export interface UpdateLoanResponse {
  success: boolean;
  message: string;
}

const updateLoan: MutationFunction<
  UpdateLoanResponse,
  UpdateLoanParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateLoanResponse>(
    `/loans/${args.loanId}`,
    {
      method: 'PUT',
      body: {
        metadata: args.metadata,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to update loan');
};

export default updateLoan;

const _mockType: UpdateLoanResponse = {
  success: true,
  message: 'success',
};
